import { useEffect, useState } from "react";
import { fetchData } from "../hooks/fetchData";
import { IconUserImages, IconUserChristmasImages } from "../components/elements/Icon";
import { checkChristmas } from "../hooks/useCheckChristmas";
import { useSelector } from 'react-redux';

const CATEGORIES = [
  { label: "Adding", value: "adding" },
  { label: "Sorting", value: "sorting" },
  { label: "Schulte", value: "schulte" },
  { label: "Division", value: "division" }
];

function TopScoresTable() {

  const [scores, setScores] = useState([]);
  const [openCategories, setOpenCategories] = useState(false);
  const [loading, setLoading] = useState(false);
  const [scope, setScope] = useState("world");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [currentCategory, setCurrentCategory] = useState(CATEGORIES[0]);
  const user = useSelector((state) => state.user)
  const deviceToken = user.user?.userEmail
  useEffect(() => {
    const category = CATEGORIES.find(c => c.value === scope);
    if (category) setCurrentCategory(category);
  }, [scope]);

  useEffect(() => {
    if (!deviceToken) return;

    const fetchTopScores = async () => {
      try {
        setLoading(true);


        const response = await fetchData(
          `/score/top?scope=${scope}`,
          "get",
          null,
          { devicetoken: deviceToken }
        );


        setScores(response.data.data || []);
      } catch (err) {
        console.error("Failed to fetch top scores", err);
        setScores([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTopScores();
  }, [scope, deviceToken]);

  return (
    <div className="w-full relative"
      style={{
        padding: "50px"
      }}>

      {/* TOP CONTROLS */}
      <div className="flex justify-center items-center gap-2 mb-4">

        {/* World */}
        <button
          onClick={() => {
            setScope("world");
            setSelectedCategory(null);
          }}
          className={`px-4 py-2 text-sm font-semibold transition rounded-[8px] 
    ${scope === "world"
              ? "bg-yellow-400 text-[#3A2F1D]"
              : "bg-[#7F48C2] text-[#E3DDE9]"
            }`}
        >
          World
        </button>

        {/* Country */}
        <button
          onClick={() => {
            setScope("country");
            setSelectedCategory(null);
          }}
          className={`px-4 py-2 text-sm font-semibold transition rounded-[8px] 
                    ${scope === "country"
              ? "bg-yellow-400 text-[#3A2F1D]"
              : "bg-[#7F48C2] text-[#E3DDE9]"
            }`}
        >
          {user.user.country ? user.user.country : "Country"}
        </button>

        {/* Categories */}
{/* Categories */}
<div className="relative">
  <button
    onClick={(e) => {
      e.stopPropagation();
      setOpenCategories((prev) => !prev);
    }}
    className={`px-4 py-2 rounded-[8px] text-sm font-semibold transition
      ${
        selectedCategory
          ? "bg-yellow-400 text-[#3A2F1D]" // если выбрана категория — подсветка
          : "bg-[#7F48C2] text-[#E3DDE9]"   // обычное состояние
      }`}
  >
    Categories
  </button>

  {openCategories && (
    <div
      className="absolute top-full mt-2 w-[180px]
                 bg-[#F3EFFF] rounded-xl border border-purple-300
                 overflow-hidden z-50"
    >
      {CATEGORIES.map((cat) => (
        <button
          key={cat.value}
          onClick={() => {
            setSelectedCategory(cat);
            setScope(cat.value);
            setOpenCategories(false);
          }}
          className="block w-full text-left px-4 py-2 text-sm
                     text-[#4B3A6B] hover:bg-purple-100"
        >
          {cat.label}
        </button>
      ))}
    </div>
  )}
</div>
  </div>


      {/* TABLE */}
      {loading ? (
        <div className="text-center text-[#6B7280] text-sm">
          Loading...
        </div>
      ) : (
        <table
          className="w-full text-sm text-[#4B5563] bg-white"
          style={{
            border: "3px solid #BED72D",
            borderRadius: "10px",
            overflow: "hidden",
            borderCollapse: "separate",
            borderSpacing: 0,
            padding: "5px"
          }}
        >
          <tbody>
            {scores.map((item, index) => (
              <tr
                key={index}
                className="border-b"
                style={{ borderColor: "rgba(190, 215, 45, 0.4)" }}
              >
                {/* Rank */}
                <td className="py-2 w-8 text-[#6B7280]">
                  {index + 1}
                </td>

                {/* Avatar */}
                <td className="py-2 w-10">
                  <div className="w-8 h-8 rounded-full overflow-hidden bg-[#D7CCD9]
                                      flex items-center justify-center">
                    {checkChristmas() ? (
                      <IconUserChristmasImages user={item.avatar} />
                    ) : (
                      <IconUserImages user={item.avatar} />
                    )}
                  </div>
                </td>

                {/* Name */}
                <td className="py-2 font-medium text-[#4B96C9]">
                  {item.nickname}
                </td>

                {/* Score */}
                <td className="py-2 text-right font-semibold text-[#4B96C9]">
                  {item.totalPoints} <span className="text-[#C9DA67] ml-1">Score</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );

}

export default TopScoresTable;
